import Avatar from './avatar';
import Badge from './badge';
import Banner from './banner';
import Button, { ButtonGroup } from './button';
import Checkbox from './checkbox';
import Chip from './chip';
import Container from './container';
import DatePicker from './date-picker';
import Divider from './divider';
import EmptyState from './empty-state';
import {
  FormControl,
  FormControlLabel,
  FormControlHelperText,
  FormControlErrorMessage,
} from './form-control';
import Heading from './heading';
import HTML from './html';
import IconButton from './icon-button';
import InlineDialog from './inline-dialog';
import { Input } from './input';
import InputLeftAddon from './input-left-addon';
import InputRightAddon from './input-right-addon';
import Link from './link';
import ListItem from './list-item';
import { Slider, SliderFilledTrack, SliderThumb, SliderTrack } from './slider';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalCloseButton,
} from './modal';
import {
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
} from './popover';
import Radio from './radio';
import RewardsBar from './rewardsbar';
import SearchBar from './search-bar';
import SegmentedController from './segmented-controller';
import { Select, SelectItem } from './select';
import { Skeleton, SkeletonText } from './skeleton';
import StarRating from './star-rating';
import Spinner from './spinner';
import Switch from './switch';
import { Tab, TabPanel, Tabs } from './tabs';
import Text from './text';
import TextArea from './textarea';
import { Tooltip } from './tooltip';
import Toast from './toast';

const componentsTheme = {
  components: {
    Avatar,
    Badge,
    Banner,
    Button,
    Checkbox,
    Chip,
    Container,
    ButtonGroup,
    DatePicker,
    Divider,
    EmptyState,
    FormControl,
    FormControlLabel,
    FormControlHelperText,
    FormControlErrorMessage,
    Heading,
    HTML,
    IconButton,
    InlineDialog,
    Input,
    InputLeftAddon,
    InputRightAddon,
    Link,
    ListItem,
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalOverlay,
    ModalCloseButton,
    PopoverArrow,
    PopoverBody,
    PopoverCloseButton,
    PopoverContent,
    PopoverFooter,
    PopoverHeader,
    Radio,
    RewardsBar,
    SearchBar,
    Scrim: {},
    SegmentedController,
    Select,
    SelectItem,
    Skeleton,
    SkeletonText,
    Slider,
    SliderFilledTrack,
    SliderThumb,
    SliderTrack,
    Spinner,
    StarRating,
    Switch,
    Tab,
    TabPanel,
    Tabs,
    Text,
    TextArea,
    Tooltip,
    Toast,
  },
};

export default componentsTheme;
